
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("fsLhR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "AGG_NO_PROJECT_DATA", () => $270c5cf11e1379f1$export$df64fe7442e4c87b);
$parcel$export(module.exports, "default", () => $270c5cf11e1379f1$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import-whitelist

var $bFU4G = parcelRequire("bFU4G");

var $2vSU6 = parcelRequire("2vSU6");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");

var $1nb22 = parcelRequire("1nb22");

const $270c5cf11e1379f1$export$df64fe7442e4c87b = 512;
const $270c5cf11e1379f1$var$getProjectContextData = async (projectIdOrKey, cloudId)=>{
    const fetchStartTime = performance.now();
    const { data: data, errors: errors } = await (0, $eusud.performPostRequest)('/gateway/api/graphql', {
        method: 'POST',
        headers: {
            'content-type': 'application/json',
            'X-ExperimentalApi': 'JiraProject, projectStyle'
        },
        body: JSON.stringify({
            query: (0, $244a3729a91e0120$export$2b91517d6d5b4365),
            variables: {
                cloudId: cloudId,
                projectIdOrKey: projectIdOrKey
            }
        })
    });
    (0, $bFU4G.addSpanToAll)('fetch', 'fetchProjectByKeyOrId', [
        {
            name: 'network'
        }
    ], fetchStartTime, performance.now());
    if (errors != null && errors.length > 0) {
        const statusCode = errors[0].extensions?.statusCode;
        throw new (0, $jJZqs.default)(statusCode, `Fetch project context via AGG failed. Errors: ${errors.map((err)=>err.message).join(', ')}`);
    }
    const projectData = data?.jira_projectByIdOrKey;
    if (!projectData) throw new (0, $jJZqs.default)($270c5cf11e1379f1$export$df64fe7442e4c87b, 'Fetch project context via AGG succeeded but no data received');
    const { projectId: projectId, key: key, uuid: uuid, name: name, avatar: avatar, projectType: projectType, projectStyle: projectStyle, status: status, created: created, isAIEnabled: isAIEnabled, canAdministerProject: canAdministerProject } = projectData;
    return {
        projectKey: key,
        projectId: +projectId,
        projectUuid: uuid,
        projectName: name,
        avatarUrl: avatar?.medium ?? '',
        simplified: projectStyle === (0, $2vSU6.TEAM_MANAGED_PROJECT),
        projectType: (0, $2vSU6.convertToProjectType)(projectType),
        isProjectAdmin: canAdministerProject?.canPerform ?? false,
        isProjectArchived: status === (0, $2vSU6.JIRA_PROJECT_STATUS_ARCHIVED),
        created: created,
        isAIEnabled: isAIEnabled
    };
};
var /**
 * Determines if the current user is an admin of the specified project by extracting project identifiers from a route, verifying these identifiers, and concurrently fetching project context and user permissions. It handles errors gracefully by throwing exceptions if data retrieval fails.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
$270c5cf11e1379f1$export$2e2bcd8739ae039 = async (matchedRoute, { tenantContext: { cloudId: cloudId } })=>{
    const projectIdOrKey = (0, $1nb22.getProjectIdOrKey)(matchedRoute.match, matchedRoute.query);
    if (projectIdOrKey == null || projectIdOrKey === '') return null;
    return $270c5cf11e1379f1$var$getProjectContextData(projectIdOrKey, cloudId);
};

});
const $244a3729a91e0120$export$2b91517d6d5b4365 = `
query jiraProject($cloudId: ID!, $projectIdOrKey: String!) {
  jira_projectByIdOrKey(cloudId: $cloudId, idOrKey: $projectIdOrKey) {
    id
    projectId
    key
    uuid
    name
    avatar {
      medium
    }
    projectType
    projectStyle
    status
    created
    isAIEnabled
    canAdministerProject: action(type:EDIT_PROJECT_CONFIG) {
      canPerform
    }
  }
}`;



//# sourceMappingURL=async-resource-project-context.9d3b6c86.js.map
